import { SELECT_HEALTH_CARE_FACILITY_TITLE } from "../../../../../../shared/constants/stringLiterals";
import { InfoIcon } from "../../../../../../shared/svg/info-icon";

const SelectHealthCareFacility = () => {
  return (
    <div className="select-health-care-facility h-full gap-2 flex-col-center">
      <div className="select-health-care-facility__icon">
        <InfoIcon height="2rem" width="2rem" stroke="#0066ff" />
      </div>
      <div className="select-health-care-facility__title text-sm font-semibold">
        {SELECT_HEALTH_CARE_FACILITY_TITLE}
      </div>
    </div>
  );
};

export default SelectHealthCareFacility;
